import { a as languages } from "../../core-8vQkh0Rd.js";
import { r as insertBefore, t as clone } from "../../language-D-vtM55V.js";
import "./c.js";
//#region src/prism/languages/cilkc.js
insertBefore(languages["cilk-c"] = languages.cilkc = clone(languages.c), "function", { "parallel-keyword": {
	pattern: /\bcilk_(?:for|reducer|s(?:cope|pawn|ync))\b/,
	alias: "keyword"
} });
//#endregion

//# sourceMappingURL=cilkc.js.map